<template>
    <div class="task-management parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <task-tutorial></task-tutorial>
        <div class="tool-bar-mask"></div>
        <!-- <Breadcrumb /> -->
        <h1>委託房客</h1>
        <div class="btn-group">
            <button @click="openTaskTutorial()" class="border-button open-task-tutorial">
                委託說明
            </button>
            <div class="insert-task">
                <router-link :to="{ name: 'NewTask'}" >
                    <img src="@/assets/img/icon/plus_white.svg" alt="">
                    新增委託
                </router-link>
            </div>
            <!-- <table-search @changeWord="setFilterWord" :setDefault="filterWordIsEmpty"></table-search> -->
        </div>
        <tabs class="tabs-wrap" :key="componentKey">
            <tab name="進行中" :selected="selected.process">
                <task-process-list></task-process-list>
            </tab>
            <tab name="已結束" :selected="selected.finished">
                <task-done-list></task-done-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import taskProcessList from '@/components/landlord/taskManagement/taskProcessList.vue';
import taskDoneList from '@/components/landlord/taskManagement/taskDoneList.vue';
import taskTutorial from '@/components/widge/modal/taskTutorial.vue';
import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            componentKey: 0,
            selected: {
                process: false,
                finished: false,
            },
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        this.$analytics.logEvent('委託房客', { screen_name: '委託房客'})
        window.addEventListener('scroll', this.handleScroll);
        console.log(this.$cookie.get('isFirstTask'))
        if(!this.$cookie.get('notFirstTask')){
            this.openTaskTutorial()
            this.$cookie.set('notFirstTask', true, { expires: '1Y' });
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        }
        
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openTaskTutorial: function () {
            this.$analytics.logEvent('委託說明', { screen_name: '委託說明'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'taskTutorial'})
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#進行中' ){
                this.$analytics.logEvent('委託房客_進行中', { screen_name: '委託房客_進行中'})
                this.selected.process = true
            }else if( hashTag == '#已結束' ){
                this.$analytics.logEvent('委託房客_已結束', { screen_name: '委託房客_已結束'})
                this.selected.finished = true
            }else{
                this.$analytics.logEvent('委託房客_進行中', { screen_name: '委託房客_進行中'})
                this.selected.process = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.process = false
            this.selected.finished = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
    },
    computed: {
        ...mapGetters({
            filterWordIsEmpty: 'GET_LEASE_MGT_FILTER_WORD_IS_EMPTY',
            isModalMode: 'GET_MODAL_MODE'

        })
    },
    components: {
        Tabs,
        Tab,
        Breadcrumb,
        RentSelect,
        taskProcessList,
        taskDoneList,
        TableSearch,
        taskTutorial
    }
}
</script>
<style lang="scss">
    .task-management{
        position: relative;
        margin-top: 42px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        > .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: -10px;
            right: 20px;
            .open-task-tutorial{
                width: 120px;
                margin-right: 16px;
            }
            .insert-task{
                width: 92px;
                cursor: pointer;
                border-radius: 4px;
                background-color: #ff9275;
                margin-right: 16px;
                padding: 0 14px;
                a{
                    height: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                }
            }
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
        }
        .tabs{
            position: absolute;
            top: 2px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
    }
    .task-management.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        > h1{
            position: fixed;
            top: -4px;
            z-index: 8;
        }
        
        .tabs{
            position: fixed;
            margin-left: 152px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
            .table-list{
                border-radius: 0 0 10px 10px;
                > .btn-group{
                    position: fixed;
                    top: 18px;
                    right: unset;
                    z-index: 10;
                    margin-left: 788px;
                }
                .mask{
                    position: fixed;
                    background: #f6f6f6;
                    width: 1190px;
                    height: 50px;
                    top: 81px;
                    margin-left: -15px;
                    z-index: 9;
                }
                .table-list-title{
                    position: fixed;
                    // width: 1094px;
                    background: #fff;
                    top: 96px;
                    border-radius: 10px 10px 0 0 ;
                    z-index: 9;
                }
            }
            
        }
    }
    @media screen and (max-width: 1280px) {
        .task-management{
            .btn-group{
                right: 34px;
            }
        }
        .task-management.fixed{
            .tool-bar-mask{
                margin-left: -24px;
            }
            
            .tabs-details{
                .table-list{
                    .table-list-title{
                        width: 1082px;
                    }
                    >.btn-group{
                        margin-left: 775px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/TaskManagementPages/TaskManagementDefault.vue